/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      20 February 2024
 */

import Hero from '../Components/Hero';

const AboutUs = () => {
  return (
    <Hero
      component={
        <>
          <h1 className='text-2xl text-dark-50 font-loos font-semibold text-center'>
            About Us
          </h1>
          <p className='font-loos text-md lg:text-xl text-dark-200 text-center mt-4'>
            We are a team driven by the passion to turn big dreams into reality.
            Always seeking new adventures to broaden our horizons and push our
            boundaries, we are equipped with diverse experiences and expertise
            to overcome any challenge that comes our way. Focusing on our
            clients&apos; needs, we work to bring their unique visions to life.
            Each project comes with its own set of requirements, and we tailor
            our approach and team to meet these specific needs, ensuring we
            deliver the best results possible. With our experience and
            expertise, we are well-equipped to tackle creative challenges,
            providing the knowledge and skills necessary to deliver top-quality
            service for each project. We don&apos;t just see ourselves as
            service providers; we also act as partners, dedicated to supporting
            you in realizing your vision and achieving success in your
            endeavors. We are here to collaborate with you and eagerly look
            forward to assisting you in your unique projects.
          </p>
        </>
      }
    />
  );
};
export default AboutUs;
